import type { FuelType } from '@/types';

// ============================================================================
// API Configuration
// ============================================================================

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';
export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN || '';

// ============================================================================
// Map Defaults
// ============================================================================

// Default to central UK
export const DEFAULT_MAP_CENTER = {
  lat: 54.0,
  lng: -2.0,
};

export const DEFAULT_MAP_ZOOM = 6;
export const SEARCH_RESULT_ZOOM = 11;
export const STATION_DETAIL_ZOOM = 14;

// ============================================================================
// Search Defaults
// ============================================================================

export const DEFAULT_RADIUS = 5; // miles
export const MIN_RADIUS = 1;
export const MAX_RADIUS = 50;

// ============================================================================
// Fuel Types
// ============================================================================

export const FUEL_TYPE_LABELS: Record<FuelType, string> = {
  E10: 'Unleaded (E10)',
  E5: 'Premium Unleaded (E5)',
  B7_STANDARD: 'Diesel',
  B7_PREMIUM: 'Premium Diesel',
  B10: 'Diesel (B10)',
  HVO: 'HVO Diesel',
};

export const FUEL_TYPE_SHORT_LABELS: Record<FuelType, string> = {
  E10: 'E10',
  E5: 'E5',
  B7_STANDARD: 'Diesel',
  B7_PREMIUM: 'Prem Diesel',
  B10: 'B10',
  HVO: 'HVO',
};

export const FUEL_TYPE_COLORS: Record<FuelType, string> = {
  E10: '#22C55E',
  E5: '#10B981',
  B7_STANDARD: '#F59E0B',
  B7_PREMIUM: '#F97316',
  B10: '#EAB308',
  HVO: '#14B8A6',
};

export const DEFAULT_PRIMARY_FUEL_TYPE: FuelType = 'E10';

// ============================================================================
// Price Tiers
// ============================================================================

export const PRICE_TIER_COLORS = {
  cheap: '#22C55E',
  average: '#F59E0B',
  expensive: '#EF4444',
};

// Percentile thresholds
export const PRICE_TIER_THRESHOLDS = {
  cheap: 25, // Bottom 25%
  expensive: 75, // Top 25%
};

// ============================================================================
// Amenities
// ============================================================================

export const AMENITY_LABELS: Record<string, string> = {
  car_wash: 'Car Wash',
  customer_toilets: 'Toilets',
  water_filling: 'Water',
  adblue_packaged: 'AdBlue (Packaged)',
  adblue_pumps: 'AdBlue Pumps',
  atm: 'ATM',
  ev_charging: 'EV Charging',
  shop: 'Shop',
  food: 'Food',
};

// ============================================================================
// Brands
// ============================================================================

export const MAJOR_BRANDS = [
  'SHELL',
  'BP',
  'ESSO',
  'TEXACO',
  'GULF',
  'JET',
  'MURCO',
];

export const SUPERMARKET_BRANDS = [
  'TESCO',
  'SAINSBURYS',
  'ASDA',
  'MORRISONS',
  'WAITROSE',
  'CO-OP',
];

// ============================================================================
// Time & Date
// ============================================================================

export const UK_TIMEZONE = 'Europe/London';

// ============================================================================
// Cache & Refresh
// ============================================================================

export const CACHE_STALE_TIME = 5 * 60 * 1000; // 5 minutes
export const REFETCH_INTERVAL = 10 * 60 * 1000; // 10 minutes
